import React, { useContext } from "react";
import { ChevronLeft, Grid } from "react-feather";
import { Link } from "react-router-dom";
import { Image } from "../../AbstractElements";
import CubaIcon from "../../assets/images/logo/fitFind.png";
import CustomizerContext from "../../_helper/Customizer";

const SidebarLogo = () => {
  const { mixLayout, toggleSidebar, layout, layoutURL, toggleIcon } =
    useContext(CustomizerContext);

  const openCloseSidebar = () => {
    const nextState = !toggleIcon;
    toggleSidebar(nextState);

    // Also directly manipulate DOM classes for immediate visual feedback
    const pageHeader = document.querySelector(".page-header");
    const sidebarWrapper = document.querySelector(".sidebar-wrapper");
    const bgOverlay = document.querySelector(".bg-overlay1");

    if (nextState) {
      // Collapse
      pageHeader?.classList.add("close_icon");
      sidebarWrapper?.classList.add("close_icon");
      bgOverlay?.classList.remove("active");
    } else {
      // Expand
      pageHeader?.classList.remove("close_icon");
      sidebarWrapper?.classList.remove("close_icon");
    }
  };

  const layout1 = localStorage.getItem("sidebar_layout") || layout;

  return (
    <div
      className="logo-wrapper"
      style={{ padding: "0px", backgroundColor: "rgb(47 172 176)" }}
    >
      <Link to={`${process.env.PUBLIC_URL}/pages/dashboard/`}>
        <Image
          attrImage={{
            className: "img-fluid d-inline",
            src: `${CubaIcon}`,
            alt: "",
            style: { height: "60px", width: "190px", marginTop: "13px", marginBottom: "12px", objectFit: "scale-down" },
          }}
        />
      </Link>

      <div
        className="back-btn"
        onClick={() => openCloseSidebar()}
        style={{ padding: "20px", cursor: "pointer" }}
      >
        <ChevronLeft color="white" />
      </div>
      <div
        className="toggle-sidebar"
        onClick={openCloseSidebar}
        style={{ color: "white" }}
      >
        <Grid className="status_toggle middle sidebar-toggle" />
      </div>
    </div>
  );
};

export default SidebarLogo;
